module.exports = __webpack_public_path__ + "static/media/old-west.67cbb86a.png";